import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft } from "react-feather";
import toast from "react-hot-toast";
import { useCreatePettyCashReconciliationMutation } from "../../pettyCashApi";
import { useGetBranchesQuery } from "../../../admin/adminApi";
import { useClaims } from "../../../auth/useClaims";
import { paths } from "../../../../routes/paths";
import { useDefaultFormBranch } from "../../../branchFilter/useDefaultFormBranch";

const today = () => new Date().toISOString().slice(0, 10);

const ReconciliationCreate = () => {
  const navigate = useNavigate();
  const { branches: callerBranchCodes, isAllBranches } = useClaims();
  const { data: branches = [] } = useGetBranchesQuery();
  const [createReconciliation, { isLoading }] = useCreatePettyCashReconciliationMutation();

  const availableBranches = isAllBranches
    ? branches
    : branches.filter((b) => callerBranchCodes?.includes(b.branchCode));

  const defaultBranchId = useDefaultFormBranch(availableBranches);
  const [branchId, setBranchId] = useState(defaultBranchId);
  // A new record starts on the header branch (useDefaultFormBranch, 2026-10-02); the
  // branch list loads async, so it is filled in once known unless already chosen.
  useEffect(() => {
    if (!branchId && defaultBranchId !== "") setBranchId(defaultBranchId);
  }, [defaultBranchId]); // eslint-disable-line react-hooks/exhaustive-deps
  const [reconciliationDate, setReconciliationDate] = useState(today());
  const [physicalBalance, setPhysicalBalance] = useState("");
  const [explanation, setExplanation] = useState("");

  const handleSave = async () => {
    if (availableBranches.length > 1 && !branchId) return toast.error("Branch is required");
    if (physicalBalance === "") return toast.error("Physical balance is required");
    try {
      const reconciliation = await createReconciliation({
        branchId: branchId ? Number(branchId) : undefined,
        reconciliationDate,
        physicalBalance: Number(physicalBalance),
        explanation: explanation || undefined,
      }).unwrap();
      toast.success("Reconciliation submitted");
      navigate(paths.pettyCashReconciliationDetail(reconciliation.recordGuid), { replace: true });
    } catch (error) {
      toast.error(error?.message || "Could not submit the reconciliation");
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <Link to={paths.pettyCashReconciliations} className="d-inline-flex align-items-center mb-2">
                <ArrowLeft size={16} className="me-1" /> Back to Reconciliations
              </Link>
              <h4>New Reconciliation</h4>
            </div>
          </div>
        </div>

        <div className="card mb-4">
          <div className="card-body">
            <h5 className="mb-3">Reconciliation Details</h5>
            <div className="row">
              {availableBranches.length > 1 && (
                <div className="col-md-4 mb-3">
                  <label className="form-label">Branch</label>
                  <select className="form-control" value={branchId} onChange={(e) => setBranchId(e.target.value)}>
                    <option value="">--Select--</option>
                    {availableBranches.map((b) => (
                      <option key={b.branchId} value={b.branchId}>{b.branchCode}</option>
                    ))}
                  </select>
                </div>
              )}
              <div className="col-md-4 mb-3">
                <label className="form-label">Reconciliation Date</label>
                <input type="date" className="form-control" value={reconciliationDate} onChange={(e) => setReconciliationDate(e.target.value)} />
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">Physical Balance (counted cash)</label>
                <input type="number" className="form-control" value={physicalBalance} onChange={(e) => setPhysicalBalance(e.target.value)} />
              </div>
              <div className="col-md-12 mb-3">
                <label className="form-label">Explanation (optional)</label>
                <textarea className="form-control" rows={2} value={explanation} onChange={(e) => setExplanation(e.target.value)} />
              </div>
            </div>
            <div className="d-flex gap-2">
              <button type="button" className="btn btn-primary" onClick={handleSave} disabled={isLoading}>Submit</button>
              <button type="button" className="btn btn-secondary" onClick={() => navigate(paths.pettyCashReconciliations)}>Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReconciliationCreate;
